export default __webpack_public_path__ + "media/images/phone-234995b205fb32a3492cbbec0a22f126.svg";